import { BankType, OutDebt } from '../generated/graphql';

export type FunderAgreement = {
  funder: string, agreements: { bank?: BankType, type: string, value: string, link?: string }[],
};
const agreements: FunderAgreement[] = [
  {
    funder: 'FAFP JCAP CFG',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'PA FP JCAP',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00023396&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '93263' },
      { type: 'Efecty', value: '23396' },
    ],
  },
  {
    funder: 'PA FAFP JCAP CFG',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'PA FP JCAP',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00023396&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '93263' },
      { type: 'Efecty', value: '23396' },
    ],
  },
  {
    funder: 'RF ENCORE SAS',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'RF ENCORE',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00000904&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '92215' },
      { type: 'Efecty', value: '904' },
    ],
  },
  {
    funder: 'RF JCAP SAS',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'RF JCAP SAS',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00000904&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '92215' },
      { type: 'Efecty', value: '904' },
    ],
  },
  {
    funder: 'PA FC REF NPL 1',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'REF NPL1',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00000904&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '93263' },
      { type: 'Efecty', value: '904' },
    ],
  },
  {
    funder: 'PA FP CANREF',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'FAFP CANREF',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00000904&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '93263' },
      { type: 'Efecty', value: '904' },
    ],
  },
  {
    funder: 'REFINANCIA SAS',
    agreements: [
      {
        type: 'AvalPayCenter',
        value: 'REFINANCIA',
        link: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00002006&origen=buscar',
      },
      { type: 'Canal físico oficina Bancolombia', value: '46576' },
    ],
  },
];

const normString = (str: string) => str.replace(/\s/g, '').replaceAll('.', '').toUpperCase();
export const getAgreementFromFunder = (
  outDebt: OutDebt,
) => agreements.find(
  ({ funder }) => normString(funder) === normString(outDebt.extra?.issuingEntity || ''),
)?.agreements || [];
